import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const WhatIfSimulations = () => {
	return <PlaceholderView pageType={PageType.WhatIfSimulations} text="Simulations" />;
};

export default WhatIfSimulations;
